"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorPrecedence = {
    value: [["."], ["!"], ["*", "/"], ["+", "-"], [">=", "<=", ">", "<"], ["===", "==", "!==", "!="], ["&&", "||"], ["?"], [":"], [","], ["="], [";"]],
    getLevel: function (code) {
        for (var i = 0; i < 12; i++) {
            for (var j = 0; j < exports.operatorPrecedence.value[i].length; j++) {
                if (exports.operatorPrecedence.value[i][j] === code) {
                    return i + 0.1 * j;
                }
            }
        }
        return null;
    },
    getLength: function (code, index) {
        for (var i = 0; i < this.value.length; i++) {
            var curI = this.value[i];
            for (var j = 0; j < curI.length; j++) {
                var curJ = curI[j];
                var len = curJ.length;
                if (curJ === code.slice(index, len + index)) {
                    return len;
                }
            }
        }
        return 0;
    },
    isHighPrecedence: function (ao, bo) {
        var aLevel = Math.ceil(exports.operatorPrecedence.getLevel(ao));
        var bLevel = Math.ceil(exports.operatorPrecedence.getLevel(bo));
        if (aLevel === bLevel && aLevel === 7)
            return false; //同层级从右往左计算
        return aLevel < bLevel;
    }
};
